import React from 'react'
import { intl } from 'lang/intl'

import Chyron, { ChyronSize } from './chyron'

import './next-up-chyron.scss'

interface NextUpChyronProps {
  name: string
  title?: string
}

const NextUpChyron = ({ name, title }: NextUpChyronProps) => {
  return (
    <Chyron
      size={ChyronSize.Small}
      kicker={intl.formatMessage({ defaultMessage: 'Next up' })}
    >
      <div className="nextup-speaker-info">
        <span className="name">{name}</span>
        {title && <span className="title">{title}</span>}
      </div>
    </Chyron>
  )
}

export default NextUpChyron
